/* @flow */
import React from 'react';
import { Avatar, Card, Icon, Menu, Typography } from 'antd';
import { RouterProps } from 'react-router';
import classNames from 'classnames';
import UserTypes from '@/constants/UserTypes';
import HeaderDropdown from './HeaderDropdown';
import styles from './GlobalHeader.module.pcss';

const { Paragraph } = Typography;

type Props = {
  auth: {
    profile: ProfileT,
  },
  signOut: () => void,
  routerProps: RouterProps,
};

const AvatarDropdown = ({ auth: { profile }, signOut, routerProps }: Props) => {
  const onMenuClick = (event) => {
    const { key } = event;

    if (key === 'logout') {
      signOut();
    }
    if (key === 'profile') {
      routerProps.history.push(`/user/${key}`);
    }
  };

  const getAvatarName = () => {
    if (profile.image) {
      return null;
    } else if (profile.first_name && profile.last_name) {
      return profile.first_name.charAt(0).toUpperCase() + profile.last_name.charAt(0).toUpperCase();
    }
    return <Icon type="user" />;
  };

  const renderMenuHeaderDropdown = () => {
    const userRole = UserTypes(profile.user_type);
    const userName = `${profile.first_name} ${profile.last_name}`;

    return (
      <>
        <Card bodyStyle={{ background: 'rgba(0, 0, 0, 0.025)' }}>
          <Paragraph className={styles.name}>{userName}</Paragraph>
          <Paragraph>{profile.email}</Paragraph>
          <Paragraph>{userRole}</Paragraph>
        </Card>
        <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
          <Menu.Item key="profile">
            <Icon type="edit" />
            Edit Profile
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item key="logout">
            <Icon type="logout" data-cy="logout-link" />
            Logout
          </Menu.Item>
        </Menu>
      </>
    );
  };

  return (
    <HeaderDropdown overlay={renderMenuHeaderDropdown()}>
      <span className={classNames(styles.action, styles.account)}>
        <Avatar className={styles.avatar} src={profile.image} size="large" alt="avatar" data-cy="avatar-dpopdown">
          {getAvatarName()}
        </Avatar>
      </span>
    </HeaderDropdown>
  );
};
export default AvatarDropdown;
